import createComponent from '@carvana/merch-components/createComponent';

export const YellowHorizontal = createComponent('hr', {
  className: 'mx-auto mb-16 w-28 border-2 border-solid border-yellow-400'
});

export const YellowHorizontalHero = createComponent(YellowHorizontal, {
  className: 'mt-40 sm:mt-80'
});
